import { useState } from "react";
import { useTranslation } from "react-i18next";

import EguIngredientRegistrationAutoBomInput from "../dialogTypes/EguIngredientRegistrationAutoBomInput";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function EguIngredientRegistraionAutoBomInputButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, customizeErrorMsgCallback, selectMst, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {

        if (grid) {

            setFormData({ ...(grid.selectedItems[0]) });

        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id + "update-button"} onClick={onOpen} createButtonName="EguIngredientRegistrationAutoBomInputButton" {...others} />
            <EguIngredientRegistrationAutoBomInput
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={schema ? t(`dialog.title.${schema.name}.update`) : ""}
                schema={schema}
                selectMst={selectMst}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default EguIngredientRegistraionAutoBomInputButton;

